import React from 'react';
import './CounterOfferAdjustmentTable.scss';
import { FinanceResponse } from '@upstart/harmony/lib/legos/financingTypes';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import {
  FinancingInformationField,
  formatFinanceValue,
} from '@upstart/harmony/lib/formatter';

interface CounterOfferAdjustmentTableProps {
  financeResponse?: FinanceResponse;
}

const CounterOfferAdjustmentTable = ({
  financeResponse,
}: CounterOfferAdjustmentTableProps) => {
  const financeApplication = financeResponse?.FinanceApplication;

  if (!financeApplication || !financeResponse) {
    return null;
  }

  const renderAdjustmentRow = (
    field: FinancingInformationField,
    label: string,
  ) => {
    const requestedValue = formatFinanceValue(
      financeApplication.data?.[field] ?? 0,
      field,
    );
    const responseValue = formatFinanceValue(
      financeResponse.data?.[field] ?? 0,
      field,
    );

    const valueChanged = requestedValue !== responseValue;

    return (
      <TableRow className={valueChanged ? 'highlight-value-changed' : ''}>
        <TableCell>{label}</TableCell>
        <TableCell align="right">{requestedValue}</TableCell>
        <TableCell align="right">{responseValue}</TableCell>
      </TableRow>
    );
  };

  return (
    <div data-testid="CounterOfferAdjustmentTable">
      <div className="counterOfferAlert">
        <h4>Upstart&apos;s Approval</h4>
        <div className="counterOfferAlert-text">
          Upstart has auto-adjusted values to approve this deal.
        </div>
      </div>
      <Table>
        <TableHead className="adjustmentTableHeader">
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell align="right">Original Requested Amount</TableCell>
            <TableCell align="right">Upstart&apos;s Approval</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {renderAdjustmentRow('financeAmount', 'Finance Amount')}
          {renderAdjustmentRow('downPayment', 'Down Payment')}
          {renderAdjustmentRow('monthly', 'Monthly Payment')}
          {renderAdjustmentRow('months', 'Term')}
        </TableBody>
      </Table>
    </div>
  );
};

export default CounterOfferAdjustmentTable;
